// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { TrackerConfigType } from "./Shared.TrackerConfigType.gen";

export interface ITrackerConfigSummary {
	id: string | undefined;

	name: string | undefined;

	type: TrackerConfigType;

	$type?: string | undefined;
}
export class TrackerConfigSummary {
	constructor(data?: ITrackerConfigSummary) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	id: string | undefined;

	name: string | undefined;

	type: TrackerConfigType = 0;

	static $type: string = "CoreApi.Models.TrackerConfigSummary, ";
	$type?: string | undefined = TrackerConfigSummary.$type;
}

